import type React from "react";

type Props = {
  children: React.ReactNode;
};

export const LayoutPaddinCheckout: React.FC<Props> = ({ children }: Props) => {
  return (
    <div className="p-2">
      <div className="form-check form-check-inline">{children}</div>
    </div>
  );
};
